import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TcpaConsentLink } from 'projects/borrower-app/src/app/models/tcpa-consent-link.model';
import { DataService } from './data.service';

// LLS-1039: the consent page is anonymous - the company and message guids in the emailed link identify the
// recipient - so these calls never go through the authenticated client.
@Injectable({ providedIn: 'root' })
export class TcpaConsentLinkService {

  constructor(private readonly _dataService: DataService) { }

  getConsentLink = (companyGuid: string, messageGuid: string): Observable<TcpaConsentLink> =>
    this._dataService.getWithoutAuth(`api/tcpa-consent-link/${encodeURIComponent(companyGuid)}/${encodeURIComponent(messageGuid)}`);

  submitConsent = (companyGuid: string, messageGuid: string, languageCode: string, consentVersion: string): Observable<TcpaConsentLink> =>
    this._dataService.postWithoutAuth(`api/tcpa-consent-link/${encodeURIComponent(companyGuid)}/${encodeURIComponent(messageGuid)}`, { languageCode, consentVersion });
}
